/**
 * 데이터(DB)에서 온 외부 링크를 화면에 그리기 전에 거르는 도우미.
 * http: · https: 만 통과시키고, 그 밖(javascript: · data: · vbscript: 등)이거나 해석할 수 없으면 undefined —
 * 호출하는 쪽은 undefined이면 링크를 그리지 않는다.
 *
 * @param assumeHttps 스킴 없이 "example.com"처럼 저장된 값(공급사 홈페이지)에 https://를 붙여 준다.
 */
export function safeHttpUrl(url: string | null | undefined, assumeHttps = false): string | undefined {
  const raw = url?.trim();
  if (!raw) return undefined;
  const candidate = assumeHttps && !/^https?:\/\//i.test(raw) ? `https://${raw}` : raw;
  try {
    const parsed = new URL(candidate);
    return parsed.protocol === "http:" || parsed.protocol === "https:" ? candidate : undefined;
  } catch {
    return undefined;
  }
}
